<template>
    <div class="ploty-container" style="width: 500px;" >
        <div class="title-estacion" v-if="station">
            <div>Estación {{station.name}}</div>
            <div v-if="campaign_datas_filtered[this.selected_campaign_data]" class="subtitle-left">{{ campaign_datas_filtered[this.selected_campaign_data].date }}</div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="subtitle-estacion">           
                    <div class="subtitle-right">{{ selected_param_data.name }}</div>
                </div>
                <Plotly v-if="show_graph" :data="data" :layout="layout" chartRelayout() :scrollZoom="true" :displaylogo="false" :modeBarButtonsToRemove="['resetScale2d', 'hoverCompareCartesian', 'hoverClosestCartesian']"></Plotly>
            
            </div>
            <div class="col-6">
                <div v-if="selected_param_compare != 0" class="subtitle-estacion">           
                    <div class="subtitle-right">{{ selected_param_compare_data.name }}</div>
                </div>
                <Plotly v-if="selected_param_compare != 0" :data="data_compare" :layout="layout_compare" chartRelayout() :scrollZoom="true" :displaylogo="false" :modeBarButtonsToRemove="['resetScale2d', 'hoverCompareCartesian', 'hoverClosestCartesian']"></Plotly>
            </div>

            <!-- COMPARE BLOCK -->
            <div class="bottom-block-compare">
                <div class="compare-with-text">Comparar con:</div>
                <div class="compare-type-selector">
                    <input type="radio" id="compare-type-none" value="none" v-model="compare_type" @click="getStationData(station.pk,'original',''); resetCompareParams();">
                    <label for="compare-type-none" class="compare-type-options-text">Nada</label>
                    <input type="radio" id="compare-type-stations" value="stations" v-model="compare_type" @click="resetCompareParams()">
                    <label for="compare-type-stations" class="compare-type-options-text">Otras estaciones</label>
                    <input type="radio" id="compare-type-params" value="params" v-model="compare_type" @click="getStationData(station.pk,'original','')">
                    <label for="compare-type-params" class="compare-type-options-text">Otros parámetros</label>
                </div>
            
                <div class="compare-station-container" v-if="compare_type=='stations'">              
                    <!-- <label  class="title-compare-station">Comparar estación</label> -->
                    <div class="input-group">
                        <select id="plataforma" class="custom-select" v-model="station_add">
                            <option
                            v-for="(station, index) in platforms"
                            :key="index"
                            :label="station.properties.name"
                            :value="station.properties">
                            </option>
                        </select>
                    </div>
                    <div @click="getStationData(station_add.pk,'compare',station_add.name)" class="button-layer-main">
                        Añadir
                    </div>
                    <div @click="getStationData(station.pk,'original','')" class="button-layer-main">
                        Reset
                    </div>
                </div>

                <div class="compare-station-container" v-if="compare_type=='params'">              
                    <div class="input-group">
                        <select id="compare-param-select" class="custom-select" v-model="selected_param_compare">
                            <option label="Ninguno" value="0"></option>
                            <option label="Concentración de Oxígeno" value="1"></option>
                            <option label="Porcentaje de Oxígeno" value="2"></option>
                            <option label="Clorofila" value="3"></option>
                            <option label="Salinidad" value="4"></option>       
                        </select>
                    </div>
                </div>

            </div>
            <div class="mt-4 ml-3">
                <div class="form-check">
                    <input class="form-check-input mt-0" type="checkbox" v-model="hideSub" @click="showSubBajParams('sub')" id="ocultarSubida">
                    <label class="compare-type-options-text m-0" for="ocultarSubida">
                        Ocultar subida
                    </label>
                </div>
                <div class="form-check mt-1">
                    <input class="form-check-input mt-0" type="checkbox" v-model="hideBaj" @click="showSubBajParams('baj')"  id="ocultarBajada">
                    <label class="compare-type-options-text m-0" for="ocultarBajada">
                        Ocultar bajada
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'
  // Functions
  import { getData } from '@/services/api'
  // Plotly
  import { element, Plotly } from 'vue-plotly'

  export default {
    name: 'popUpGraph',
    components: {
        Plotly
    },
    props: {
        station: '',
        platforms: '',
    },
    computed:{
        ...mapGetters(
            "map_params",{
                stations_or_density: 'stations_or_density',
                selected_param: 'selected_param',
                selected_campaign_data: 'selected_campaign_data',
                campaign_datas_filtered: 'campaign_datas_filtered'
            }
        ),
        selected_param_compare: {
            set (param) { this.$store.dispatch('map_params/change_selected_param_compare', parseInt(param)); },
            get () { return this.$store.state.map_params.selected_param_compare }
        },
    },
    data: function () {
        return {
            compare_type: 'none',
            show_graph: false,
            raw_data: null,
            paramSubida: [],
            paramBajada: [],
            stations_compare: [],
            station_add: '',
            hideSub: false,
            hideBaj:false,
            selected_param_data: {
                codename: '',
                name: '',
                unit: '',
            },
            selected_param_compare_data: {
                codename: '',
                name: '',
                unit: '',
            },
            data: [
                {
                    x: [],
                    y: [],
                    name: 'Bajada',
                    mode: 'lines',
                    hoverinfo: 'skip',
                    line: {
                        width: 2
                    },
                },
                {
                    x: [],
                    y: [],
                    name: 'Subida',
                    mode: 'lines',
                    hoverinfo: 'skip',
                    line: {
                        width: 2
                    },
                }
            ],
            data_compare: [
                {
                    x: [],
                    y: [],
                    name: 'Bajada',
                    mode: 'lines',
                    hoverinfo: 'skip',
                    line: {
                        width: 2
                    },
                },
                {
                    x: [],
                    y: [],
                    name: 'Subida',
                    mode: 'lines',
                    hoverinfo: 'skip',
                    line: {
                        width: 2
                    },
                }
            ],
            layout:{
                yaxis: {
                    autorange: 'reversed',
                    title: {
                        text: 'Profundidad [m]'
                    },
                // type: 'log',
                // autorange: true,
                // showexponent: 'all',
                // exponentformat: 'power'
                },
                xaxis: {
                    title: {
                        text: '[DO mg/L]'
                    },
                    // type: 'log',
                    autorange: true,
                    // showexponent: 'all',
                    // exponentformat: 'power'
                },
                // plot_bgcolor:"#052030",
                // paper_bgcolor:"#FFF3",
                dragmode: 'pan',
                modebar: {
                    bgcolor: 'rgba(0,0,0,0)',
                    color: '#9590a0',
                    activecolor: '#5570a0',
                    orientation: 'v'
                },
                height: 300,
                width: 500,
                margin: {
                    t: 10,
                    r: 100
                },
                // hoverlabel: {
                //     font: {
                //         color: 'white'
                //     }
                // }
            },
            layout_compare:{}
        }
    },
    mounted () {
        this.layout_compare = this.layout
        this.changeSelectedParamData()
    },
    watch: {
        'stations_or_density': function () {
            //console.log(this.stations_or_density)
        },
        'selected_param': function () {
            this.changeSelectedParamData()
        },
        'selected_param_compare': function () {
            this.changeSelectedParamCompareData()
        },
        'selected_campaign_data': function () {
            if (this.station != null){
                this.getStationData(this.station.pk,'original','') 
            }
               
        },
        'station': function () {
            this.getStationData(this.station.pk,'original','')
        }
    },
    methods: {
        getStationData(station_pk,type,name) {
            if(this.station && this.campaign_datas_filtered[this.selected_campaign_data]) {
                this.show_graph = true
                var url = 'mmdata/water-parameter-data/' + station_pk + '/' + this.campaign_datas_filtered[this.selected_campaign_data].id + '/'
                getData(url).then(res=> {
                    //if(this.raw_data != null) {
                        this.raw_data = res.data
                    //}        
                    if(document.getElementsByClassName("leaflet-popup-content")) {
                        if(document.getElementsByClassName("leaflet-popup-content")[0] != undefined){ 
                            this.splitData(type,name,false)
                        }
                    }
                })
            }        
        },
        splitData: function(type,name,compare_table,compare_another_param=false) {
            var data = ''
            if (compare_table){
                data = this.data_compare
            }else{
                data = this.data
            }
            if(type != "original"){
                this.data[0].name = 'Baj (' + this.station.name +')'
                this.data[1].name = 'Sub (' + this.station.name +')'
                data.push({           
                    x: [],
                    y: [],
                    name: 'Baj (' + name +')',
                    mode: 'lines',
                    hoverinfo: 'skip',
                    line: {
                        //color: 'rgba(55, 210, 242, 0.7)',
                        width: 2
                    },
                })
                data.push({
                    x: [],
                    y: [],
                    name: 'Sub (' + name +')',
                    mode: 'lines',
                    hoverinfo: 'skip',
                    line: {
                        //color: 'rgba(55, 210, 242, 0.7)',
                        width: 2
                    },
                })
            }else{
                this.data[0].name = 'Bajada'
                this.data[1].name = 'Subida'
                data[0].x = []
                data[0].y = []
                data[1].x = []
                data[1].y = []
                data.splice(2) 
            }

            var index = data.length
            let selectedParamData = []
            if(compare_another_param) {
                if(this.raw_data != null) {
                    selectedParamData = this.raw_data[this.selected_param_compare_data.codename]
                }
            } 
            else {
                if(this.raw_data != null) {
                    selectedParamData = this.raw_data[this.selected_param_data.codename]
                }       
            }
            if (this.selected_param_compare == 0) {
                if(document.getElementsByClassName("leaflet-popup-content")) {
                    if(document.getElementsByClassName("leaflet-popup-content")[0] != undefined) { 
                        document.getElementsByClassName("leaflet-popup-content")[0].style.width = "500px"; 
                        document.getElementsByClassName("ploty-container")[0].style.width = "500px";  
                    }
                }
            }
            else {
                if(document.getElementsByClassName("leaflet-popup-content")) {
                    if(document.getElementsByClassName("leaflet-popup-content")[0] != undefined) { 
                        document.getElementsByClassName("leaflet-popup-content")[0].style.width = "1000px"; 
                        document.getElementsByClassName("ploty-container")[0].style.width = "1000px"; 
                    }
                }
            }
                
            this.setParams(selectedParamData)
        
            this.paramBajada.forEach(measure => {
                data[index - 2].x.push(measure[0])
                data[index - 2].y.push(measure[1])
            })
            this.paramSubida.forEach(measure => {
                data[index - 1].x.push(measure[0])
                data[index - 1].y.push(measure[1])
            })

            if (compare_table){
                this.data_compare = data
                this.layout_compare.xaxis.title.text = this.selected_param_compare_data.unit
                this.layout_compare.xaxis.autorange = true
                this.layout_compare.yaxis.autorange = 'reversed'
            }else{
                this.layout.xaxis.title.text = this.selected_param_data.unit
                this.layout.xaxis.autorange = true
                this.layout.yaxis.autorange = 'reversed'
            }
            
            this.showSubBajParams('none')

        },
        showSubBajParams: function(type){
            if (type == 'sub'){
                this.hideSub = !this.hideSub
                if (this.hideBaj){
                    this.hideBaj = false
                }
            } 
            else if (type == 'baj'){
                this.hideBaj = !this.hideBaj
                if (this.hideSub){
                    this.hideSub = false
                }
            }

            var styleSub = document.createElement('style');
            if (this.hideSub){
                this.data.forEach(element => {
                    if (element.name == 'Subida' || element.name.substring(0,3) == 'Sub')
                        element.mode = 'none'
                });
                styleSub.innerHTML = '.infolayer > .legend > .scrollbox >.groups > g:nth-child(even){display: none;}';
            }else{
                this.data.forEach(element => {
                    if (element.name == 'Subida' || element.name.substring(0,3) == 'Sub')
                        element.mode = 'line'
                });
                styleSub.innerHTML = '.infolayer > .legend > .scrollbox >.groups > g:nth-child(even){display: block;}';
            }
            document.getElementsByTagName('head')[0].appendChild(styleSub);

            var styleBaj = document.createElement('style');
            if (this.hideBaj){
                this.data.forEach(element => {
                    if (element.name == 'Bajada' || element.name.substring(0,3) == 'Baj')
                        element.mode = 'none'
                });
                styleBaj.innerHTML = '.infolayer > .legend > .scrollbox >.groups > g:nth-child(odd){display: none;}';
            }else{
                this.data.forEach(element => {
                    if (element.name == 'Bajada' || element.name.substring(0,3) == 'Baj')
                        element.mode = 'line'
                });
                styleBaj.innerHTML = '.infolayer > .legend > .scrollbox >.groups > g:nth-child(odd){display: block;}';
            }
            document.getElementsByTagName('head')[0].appendChild(styleBaj);
    
        },
        setParams: function(selectedParamData) {
            this.paramSubida = []
            this.paramBajada = []
            let values = []
            let bajada = true
            selectedParamData.forEach(value => {
                values.push(parseFloat(value.y))
            })

            let maxValue = Math.max(...values)

            selectedParamData.forEach(value => {
                if (parseFloat(value.y) == maxValue) {
                    bajada = false
                }
                if (bajada) {
                    this.paramBajada.push(Object.values(value))
                } else {
                    this.paramSubida.push(Object.values(value))
                }
            })
            this.paramBajada.sort((a, b) => a.y - b.y)
            this.paramSubida.sort((a, b) => b.y - a.y)

            this.paramBajada = this.paramBajada.map(arr => {
                return arr.map(val => Number(val))
            })

            this.paramSubida = this.paramSubida.map(arr => {
                return arr.map(val => Number(val))
            })
        },
        changeSelectedParamData: function() {
            let name = ''
            let codename = ''
            let unit = ''
            switch (this.selected_param) {
                case 1:
                    codename = 'ConOxigenoDisuelto'
                    name = 'Concentración de Oxígeno Disuelto'
                    unit = 'ODO mg/L'
                    break
                case 2:
                    codename = 'PorOxigenoDisuelto'
                    name = 'Porcentaje de Oxígeno Disuelto'
                    unit = 'ODO %'
                    break
                case 3:
                    codename = 'Clorofila'
                    name = 'Clorofila'
                    unit = 'CHL ug/L'
                    break
                case 4:
                    codename = 'Salinidad'
                    name = 'Salinidad'
                    unit = 'SAL PSU'
                    break
            }
            let tmpObject = {}
            tmpObject.codename = codename
            tmpObject.name = name
            tmpObject.unit = unit
            this.selected_param_data = tmpObject

            if(this.station) {
                this.splitData('original','',false)
            }
        },
        changeSelectedParamCompareData: function() {
            let name = ''
            let codename = ''
            let unit = ''
            switch (this.selected_param_compare) {
                case 0:
                    codename = ''
                    name = ''
                    unit = ''
                    break
                case 1:
                    codename = 'ConOxigenoDisuelto'
                    name = 'Concentración de Oxígeno Disuelto'
                    unit = 'DO mg/L'
                    break
                case 2:
                    codename = 'PorOxigenoDisuelto'
                    name = 'Porcentaje de Oxígeno Disuelto'
                    unit = 'DO %'
                    break
                case 3:
                    codename = 'Clorofila'
                    name = 'Clorofila'
                    unit = 'Chl ug/L'
                    break
                case 4:
                    codename = 'Salinidad'
                    name = 'Salinidad'
                    unit = 'SAL-ppt'
                    break
            }
            let tmpObject = {}
            tmpObject.codename = codename
            tmpObject.name = name
            tmpObject.unit = unit
            this.selected_param_compare_data = tmpObject

            let compare_with_another_param = true
            if(this.selected_param_compare == 0) {
                compare_with_another_param = false
            }
            if(this.station) {
                this.splitData('original','',true,compare_with_another_param)
            }
        },
        resetCompareParams: function() {
            this.selected_param_compare = 0
        }
    }
  }
</script>

<style scoped>
    .bottom-block-compare {
        display: flex;
        flex-direction: column;
        margin-left: 25px;
    }
    .compare-with-text {
        color: #447998;
        font-size: 0.9rem;
        border-top: 1px solid #44799830;
        padding-top: 12px;
        padding-bottom: 6px;
    }
    .compare-type-options-text {
        color: #447998;
        font-size: 0.8rem;
        padding-left: 2px;
        padding-right: 10px;
    }
    .compare-station-container {
        display:flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .title-estacion {
        display: flex;
        flex-direction: row;
        color: #447998;
        font-weight: 600;
        font-size: 1.1rem;
        justify-content: space-between;
    }
    .subtitle-estacion {          
        text-align: center;
        color: #447998;
        font-size: 0.9rem;
        border-bottom: 1px solid #44799830;
        padding-bottom: 12px;
    }
    /* .compare-station-container {
        display:flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #44799830;
        padding-top: 12px;
    } */
    .title-compare-station {
        color: #447998;
        font-size: 0.9rem;
        margin-right: 10px;
        margin-bottom: 0;
    }
    .button-layer-main {
        padding: 12px;
        margin-left: 8px;
        border-radius: 50px;
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgb(165, 212, 223);
        font-size: 0.9rem;
        cursor: pointer;
        box-shadow: 4px 4px 5px #C6DDE2, 
            -5px -5px 6px #ffffff;
    }
    .button-layer-main:hover {
        color:#1CBBB4;
    }
</style>



// WEBPACK FOOTER //
// src/components/mapparams/popUpGraph.vue